// NPM Inports
import React, { useState, useRef, useEffect, useCallback } from "react";
import { connect } from "react-redux";
// Component imports
import { ConfirmationBoxV2 } from "../../../commonComponents";
import TemplateTableRow from "./TemplateTableRow";

// Action imports
import {
  deleteTemplate,
  fetchAllDocumentTemplates,
} from "../../../actions/DocumentTemplateActions/templateActions";

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS, TEMPLATE, IMAGE_URLS } from "../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;
const { TEMPLATE_STATUSES_FOR_FILTER: TEMP_STATUSES } = TEMPLATE;
const { EMPTY_PAGE_ICO } = IMAGE_URLS;

function TemplateTableBody(props) {
  const templateTableBodyRef = useRef(null);
  const [showDeletePopup, _toggleDeletePopup] = useState(false);
  const [showDeleteItemBtnLoader] = useState(false);
  const [selectedTemplateId, setSeletedTemplateId] = useState(0);
  const [loadMore, setLoadMore] = useState(false);

  const _loadMoreTemplates = useCallback(() => {
    if (
      window.innerHeight + templateTableBodyRef.current.scrollTop >=
      templateTableBodyRef.current.scrollHeight
    ) {
      // make api call
      const {
        fetchDocumentTemplates,
        pageNum,
        hasMore,
        showSearchPage,
        templatesStatusFilters,
      } = props;
      // Exclude search page
      if (!loadMore && hasMore && !showSearchPage) {
        setLoadMore(true);
        // const appliedFilters =
        //   filterParams || ;
        let payload = "";
        if (templatesStatusFilters.length > 0) {
          templatesStatusFilters.forEach((i, idx) => {
            if (idx === 0) {
              payload = `${TEMP_STATUSES[i].status}`;
            } else {
              payload = `${payload},${TEMP_STATUSES[i].status}`;
            }
          });
        }
        fetchDocumentTemplates(pageNum + 1, true, templatesStatusFilters)
          .then(() => {
            setLoadMore(false);
          })
          .catch(() => {
            setLoadMore(false);
          });
      }
    }
  }, [loadMore, props]);

  useEffect(() => {
    const templateTableBodyReference = templateTableBodyRef;
    templateTableBodyReference.current.addEventListener(
      "scroll",
      _loadMoreTemplates,
    );
    return () => {
      if (templateTableBodyReference && templateTableBodyReference.current) {
        templateTableBodyReference.current.removeEventListener(
          "scroll",
          _loadMoreTemplates,
        );
      }
    };
  }, [_loadMoreTemplates]);

  const { templates, templatesStatusFilters } = props;
  return (
    <div ref={templateTableBodyRef} className="templatedetails-table-wrapper ">
      {templatesStatusFilters && templates.length === 0 && (
        <div className="assetdetails-emptyscreen-wrapper">
          <img
            src={EMPTY_PAGE_ICO}
            alt="empty-screen"
            className="assetdetails-emptyscreen-ico"
          />
          <div className="assetdetails-emptyscreen-text">
            <span>Oops, No results found using this filter. </span>
          </div>
        </div>
      )}
      {/* BODY SECTION */}
      <section>
        <div className="templatedetails-table-body">
          {templates &&
            templates.map(item => (
              <TemplateTableRow
                key={`${item.id}-template-list`}
                id={item.id}
                label={item.title}
                templateStatus={item.status}
                templateTag={item.template_tag}
                templateOwner={item.created_by.name || ""}
                profileUrl={item.created_by.image_url}
                lastModified={item.updated_at}
                toggleDeleteConfirmationPopup={() => {
                  _toggleDeletePopup(!showDeletePopup);
                }}
                setSeletedTemplateId={setSeletedTemplateId}
                templateUsergroups={item.usergroups}
              />
            ))}
        </div>
      </section>

      {/* CONFIRMATION POPUP SECTION */}
      <section>
        {showDeletePopup && (
          <ConfirmationBoxV2
            header="Are you sure you want to delete the selected item?"
            subHeader={`Once deleted, you won't be able to access.`}
            loaderMessage="Loading"
            showBtnLoader={showDeleteItemBtnLoader}
            closePopup={() => _toggleDeletePopup(false)}
            checkboxLabel="Yes, I want to delete."
            confirmAction={() =>
              props.deleteTemplate(selectedTemplateId).then(() => {
                _toggleDeletePopup(false);
                amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_DELETED, {
                  templateID: selectedTemplateId,
                });
              })
            }
            okBtnText="Delete"
          />
        )}
      </section>
    </div>
  );
}

const mapStateToProps = ({
  TemplateStore: {
    documentTemplatesInfo: { pageNum, hasMore },
    templatesStatusFilters,
  },
}) => ({
  pageNum,
  hasMore,
  templatesStatusFilters,
});

const mapDispatchToProps = {
  deleteTemplate,
  fetchDocumentTemplates: fetchAllDocumentTemplates,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateTableBody);
